export const CSS_SIZE_AUTO = 'auto';
export const CSS_SIZE_FIT_CONTENT = 'fit-content';

export const CSS_SIZE_UNIT_PX = 'px';
